module.exports = __webpack_public_path__ + "static/media/62.8468c7e4.png";